/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AuthForm } from "../components/Auth/AuthForm";
import { ROUTES } from "../globals/globals";
import { isLoggedInSelector } from "../store/api/auth/selectors";
import { useEffect } from "react";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(isLoggedInSelector);

  useEffect(() => {
    if (isLoggedIn) {
      navigate(ROUTES.HOME.Path, { replace: true });
    }
    // if (!isLoggedIn) {
    //   navigate(ROUTES.LOGIN.Path, { replace: true });
    // }
  }, [isLoggedIn, navigate]);

  return <AuthForm />;
};

export default LoginPage;
